export default "__VITE_ASSET__DbzkNFtZ__"